import {
  formModalScreens,
  leftMenuScreens,
  modalScreens,
  stackScreens,
} from './Routes';

const screenPaths = {};

const resolvePath = ({ path, pathParams, requiredFields, ...screen }) => {
  const { name } = screen;
  if (path) {
    screenPaths[name] = {
      path,
      pathParams,
      requiredFields,
    };
  }
  return screen;
};

const routes = {
  stackScreens: [...stackScreens].map(resolvePath),
  leftMenuScreens: [...leftMenuScreens].map(resolvePath),
  modalScreens: [...modalScreens].map(resolvePath),
  formModalScreens: [...formModalScreens].map(
    resolvePath,
  ),
};

export default routes;

export { screenPaths };
